import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Typography, useTheme } from "@mui/material";

export interface Item {
  id: string;
  name: string;
  source?: string;
  externalId?: string;
  categoryOrder: number;
}

export function SortableItem({ id, name }: Item) {
  const { palette } = useTheme();

  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
    isOver,
  } = useSortable({
    id,
    data: { name, id },
  });

  console.info(isOver, isDragging);

  const style: React.CSSProperties = {
    transform: transform ? CSS.Translate.toString(transform) : undefined,
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: "grab",
    touchAction: "none", // 👈 évite les conflits scroll/drag sur mobile
    WebkitTapHighlightColor: "transparent", // iOS : enlève le flash bleu
  };

  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      tabIndex={0}
      sx={{
        mr: 1,
        mb: 1,
        px: 2,
        py: 1,
        flex: "0 0 auto",
        borderRadius: 1,
        border: "2px solid #004998",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "#336dac",
          "& .MuiTypography-root": {
            color: "#fff",
          },
        },
        "&:focus": {
          backgroundColor: "#336dac",
          "& .MuiTypography-root": {
            color: "#fff",
          },
        },
        "&:active": {
          backgroundColor: "#336dac",
          "& .MuiTypography-root": {
            color: "#fff",
          },
        },
      }}
    >
      <Typography
        noWrap
        sx={{
          fontSize: "1rem",
          color: palette.primary.dark,
          fontWeight: "bold",
        }}
      >
        {name}
      </Typography>
    </Box>
  );
}
